<template>
<div>
  <el-calendar ref="calendar" v-model="currentDate" class="custom-calendar">
      <template #dateCell="{ data }">
      <p :class="data.isSelected ? 'is-selected' : ''">
        {{ data.day.split('-').slice(2).join('-') }}
        {{ data.isSelected ? '✔️' : '' }}
      </p>
      <span style="margin-left: 0px" v-for="item in list" :key="item">
          <el-tag style="margin-left: 5px" type="danger" v-if="(Date.parse(item.basic.outTime)<=Date.parse(data.day)&&Date.parse(item.basic.returnTime)>=Date.parse(data.day))">
              {{item.createdPeople&&item.createdPeople.name}}
          </el-tag>
      </span>
    </template>
  </el-calendar>
</div>
</template>

<script>
import moment from 'moment'
import { findPeopleRecordList, } from '@/api/oa'
import { reactive, ref, getCurrentInstance,watch } from 'vue'
import commomFunction from '../common'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'OaVacationIndex',
  setup() {
    let currentDate =ref('')
    watch(currentDate, (newVal, oldVal) => {  
      console.log(newVal.getTime());  
      queryForm.startRangeTime = newVal.getTime()-2592000000
      queryForm.endRangeTime = newVal.getTime()+2592000000
      fetchData()

    }, { deep: true });
    const list = reactive([])
    const textContent=(date)=> {
      return list.filter((item) => {
        console.log(Date.parse(item.basic.outTime),Date.parse(date),Date.parse(item.basic.returnTime));
      });
    }
    const queryForm = reactive({
      page:1,
      size:9999,
      filterMode: 3
    })
    const fetchData = async () => {
      const { list: list1, total: total1 } = await findPeopleRecordList(
        queryForm
      )
      list.length = 0
      list.push(...list1)
    }
    const queryData = () => {
      queryForm.page = 1
      fetchData()
    }
    //拉取数据
    queryData()
    return {
      list,
      queryForm,
      moment,
      currentDate,
      fetchData,
      queryData,
      textContent
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
::v-deep .el-calendar-day {
height: auto;
}
</style>
